import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as userActions } from "../../../redux/modules/user";
import { actions as activeActions } from "../../../redux/modules/active";
import { NavLink } from "react-router-dom";
import YearSelect from "../../User/components/Register/components/YearSelect";
import Active from "../../../components/Active";
import ActiveSuccess from "../../../components/ActiveSuccess";
import { put } from "../../../utils/request";
import "./style.css";
import "../../../index.css";
class My extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: "2020年高考",
      ysVisible: false,
    };
  }

  componentDidMount() {
    document.title = "我的";
  }
  render() {
    const { userInfo } = this.props;
    return (
      <div className="my_box">
        <div className="my_phone_box">
          <img alt="" src={require("../../../images/my/bg.png")}></img>
          <div className="my_phone_num_box">{userInfo.phone}</div>
        </div>
        <div
          onClick={() => this.handleShowYearSelect()}
          className="my_props_box my_bottom_line"
        >
          <div className="fl major_left_20 color_292929 font_size_16">
            高考年份
          </div>
          <div className="fr my_arrows">
            <img alt="" src={require("../../../images/article/more.png")}></img>
          </div>
          <div className="fr major_right_8 font_size_14 color_adadad">
            {userInfo.year}年高考
          </div>
        </div>
        <div className="my_props_box my_bottom_line">
          <div className="fl major_left_20 color_292929 font_size_16">
            激活码
          </div>
          {userInfo.isActive === true ? (
            <div className="fr major_right_25 font_size_14 color_adadad">
              已激活
            </div>
          ) : (
            <div onClick={() => this.handleShowActive()}>
              <div className="fr my_arrows">
                <img
                  alt=""
                  src={require("../../../images/article/more.png")}
                ></img>
              </div>
              <div className="fr major_right_8 font_size_14 color_adadad">
                输入激活码
              </div>
            </div>
          )}
        </div>
        <div className="my_props_box my_bottom_line">
          <div className="fl major_left_20 color_292929 font_size_16">
            密码设置
          </div>
          <div className="fr my_arrows">
            <img alt="" src={require("../../../images/article/more.png")}></img>
          </div>
          <NavLink
            to="/my/pwset"
            style={{ textDecoration: "none" }}
            className="fr major_right_8 font_size_14 color_adadad"
          >
            密码、退出
          </NavLink>
        </div>
        <div className="my_props_box my_bottom_line">
          <div className="fl major_left_20 color_292929 font_size_16">
            联系我们
          </div>
          <div className="fr my_arrows">
            <img alt="" src={require("../../../images/article/more.png")}></img>
          </div>
          <div className="fr major_right_8 font_size_14 color_adadad">
            <a
              style={{ textDecoration: "none", color: "#adadad" }}
              href="tel:13067852167"
            >
              13067852167
            </a>
          </div>
        </div>
        <div className="text_align_center major_top_40 major_bottom_10 color_292929 font_size_18 font-weight-bold">
          关注我们
        </div>
        <div className="my_qr_box">
          <img alt="" style={{height:'120px',width:'120px'}} src={require('../../../images/my/qrcodev3.0.png')}></img>
        </div>
        <div className="text_align_center color_9d9d9d">
          长按二维码，前往关注
        </div>
        <YearSelect
          visible={this.state.ysVisible}
          selectYear={this.state.year}
          handleCloseYearSelect={this.handleCloseYearSelect}
          handleChangYear={this.handleChangYear.bind(this)}
        ></YearSelect>
        <Active></Active>
        <ActiveSuccess></ActiveSuccess>
      </div>
    );
  }

  /**
   * 弹出激活框
   */
  handleShowActive = () => {
    const { dispatch } = this.props;
    dispatch(activeActions.setShowActive(true));
  };
  /**
   * 开启高考年份选择
   */
  handleShowYearSelect = () => {
    this.setState({
      ysVisible: true,
    });
  };
  /**
   * 关闭高考年份选择
   */
  handleCloseYearSelect = () => {
    this.setState({
      ysVisible: false,
    });
  };
  /**
   * 高考年份选择框修改高考年份
   * @param {int} year
   */
  handleChangYear = (year, visible) => {
    this.setState({
      year: year,
      ysVisible: visible,
    });
    //将高考年份更新到数据库
    put("/public/v1/user/year/" + year.replace("年高考", "")).then((res) => {
      if (res.status === "success") {
        const { dispatch } = this.props;
        let userInfo = {
          phone: this.props.userInfo.phone,
          year: parseInt(year.replace("年高考", ""),10),
          isActive: this.props.userInfo.isActive,
          isLogin: this.props.userInfo.isLogin,
          isBuy: this.props.userInfo.isBuy,
        };
        dispatch(userActions.setUserInfo(userInfo));
      }
    });
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};
export default connect(mapStateToProps)(My);



// WEBPACK FOOTER //
// ./src/containers/My/Home/index.js